export default __webpack_public_path__ + "static/media/palletflylogo.4e7266d1.svg";